export default "__VITE_ASSET__CiCKANAS__"